<template>
    <div class="leftNavBox fl">
        <ul v-if="sendSelected=='cooperation'">
            <li>
                <a class="leftNav" :class="{active:selected=='information'}" :href="'#/cooperation/information'" >基本信息</a>
            </li>
            <li >
                <a class="leftNav" :class="{active:selected=='authentication'}" :href="'#/cooperation/authentication'" >达人认证</a>
            </li>
            
        </ul>
        <ul v-if="sendSelected=='league'">
            <li>
                <a class="leftNav" :class="{active:selected=='information'}" :href="'#/league/information'" >基本信息</a>
            </li>
            <li >
                <a class="leftNav" :class="{active:selected=='authentication'}" :href="'#/league/authentication'" >认证信息</a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'top',
    data () {
        return {
            logo:'static/images/logo.png',
            sendSelected:'',
        }
    },
    props:['selected'],
    mounted(){
        var Url = window.location.href;
        var UrlPath=Url.split('/');
        for(var i in UrlPath){
            if(UrlPath[i]=='cooperation'){
                this.sendSelected='cooperation';
            }else if(UrlPath[i]=='league'){
                this.sendSelected='league';
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .leftNavBox{
        width: 150px;
        background-color: #fff;
        padding: 20px;
        text-align: center;
        box-sizing: border-box;
        .leftNav{
            display: block;
            font-size: 18px;
            line-height: 48px;
            color: #999;
            box-sizing: border-box;
            &.active{
                color: #333;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/public/leftNav.vue